<div class="container_width flex flex-column gap-4 py-4">
    <div class="w-full">
      <h1 class="text-3xl md:text-4xl lg:text-5xl mb-4" style="color: #052647;">Schedule a call</h1>
      <div class="grid">
          <!-- Left Column: Profile -->
          <div class="col-12 lg:col-3">
              <div class="profile-card flex flex-column p-4 border-round-2xl gap-3">
                  <div class="avatar-container w-4rem h-4rem border-circle overflow-hidden flex align-items-center justify-content-center">
                    <img *ngIf="peerDetail?.imageUrl; else fallbackAvatar" [src]="peerDetail?.imageUrl" class="w-full h-full object-cover" alt="avatar">
                    <ng-template #fallbackAvatar>
                      <div class="w-full h-full flex align-items-center justify-content-center" style="background-color: #DDE24A; color: #052647; font-size: 1.5rem; font-weight: bold;">
                        {{peerDetail?.firstName?.[0]}}
                      </div>
                    </ng-template>
                  </div>
                  <b class="text-white font-medium text-lg m-0">{{peerDetail?.firstName}} {{peerDetail?.lastName}}</b>
                  <h2 class="font-bold text-xl m-0" style="color: #DDE24A;">20 Minute Discovery Call</h2>
                  
                  <div class="flex flex-column gap-3 mt-3">
                      <div class="flex align-items-center gap-2">
                        <i class="pi pi-mars text-white"></i>
                        <span class="text-sm font-normal text-white">{{genderDescriptions(peerDetail?.gender)}}</span>
                      </div>
                      <div class="flex align-items-center gap-2">
                        <i class="pi pi-map-marker text-white"></i>
                        <span class="text-sm font-normal text-white">{{peerDetail?.country}}</span>
                      </div>
                      <div class="flex align-items-center gap-2">
                        <i class="pi pi-graduation-cap text-white"></i>
                        <span class="text-sm font-normal text-white">{{peerDetail?.underGraduateCollageName}}</span>
                      </div>
                  </div>

                  <div class="mt-4 flex flex-column gap-2">
                    <label class="text-xs font-bold uppercase tracking-wider" style="color: #DDE24A;">Purpose (Optional)</label>
                    <input type="text" class="p-inputtext w-full custom-purpose-input border-round-xl border-none outline-none p-2" placeholder="type here" [(ngModel)]="purpose" />
                  </div>
              </div>
          </div>

          <!-- Middle Column: Date & Time Picker -->
          <div class="col-12 lg:col-6">
              <div class="calendar-card bg-white p-4 border-round-2xl border-1" style="border-color: #F1F1F1;">
                <div class="calendar-wrapper mb-4">
                  <p-calendar
                    class="custom-calendar w-full"
                    [(ngModel)]="date"
                    [inline]="true"
                    [minDate]="mindate"
                    (onSelect)="onDateSelect($event)">
                  </p-calendar>
                </div>
                <div *ngIf="!date" class="mt-4 p-3 border-round-2xl text-center" style="background-color: #F8F9FA;">
                  <span class="text-sm" style="color: #6C757D;">Click a date to see available time slots</span>
                </div>
              </div>

              <!-- Time slots section as a separate card -->
              <div class="time-slots-card bg-white p-4 border-round-2xl border-1 mt-4" style="border-color: #F1F1F1;" *ngIf="date">
                <div class="flex justify-content-between align-items-center mb-3">
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-clock" style="color: #575B68;"></i>
                    <span class="font-medium" style="color: #052647;">{{ date | date: 'EEEE, MMMM d' }}</span>
                  </div>
                  <i class="pi pi-times cursor-pointer" style="color: #575B68;" (click)="date = undefined; timeslots = []"></i>
                </div>
                
                <div *ngIf="timeslots.length === 0" class="text-center py-3">
                  <span class="text-sm" style="color:#575B68">No time-slots available</span>
                </div>

                <div class="grid grid-nogutter justify-content-center">
                  <div class="col-3" *ngFor="let slot of timeslots" style="padding: 6px;">
                    <button 
                      class="slot-btn w-full p-2 border-round-3xl border-1 cursor-pointer font-medium text-xs transition-colors transition-duration-200 flex align-items-center justify-content-center"
                      [ngClass]="{'selected': isSlotSelected(slot)}"
                      (click)="toggleSlot(slot)">
                      <i class="pi pi-check text-xs mr-1" *ngIf="isSlotSelected(slot)"></i>
                      {{ slot.from }}
                    </button>
                  </div>
                </div>
                <div class="text-center mt-3" *ngIf="timeslots.length > 0">
                  <small style="color: #999;">Pick a time slot above, then add it to your preferences</small>
                </div>
              </div>
          </div>

          <!-- Right Column: Preferred Times -->
          <div class="col-12 lg:col-3">
            <div class="flex flex-column">
              <div class="preferred-card bg-white p-4 border-round-2xl border-1 flex flex-column gap-3" style="border-color: #F1F1F1;">
                <div class="flex justify-content-between align-items-center mb-2">
                  <h3 class="m-0 font-medium text-lg" style="color: #052647;">Your Preferred Times</h3>
                  <span class="badge text-sm px-2 py-1 border-round-2xl font-medium" style="background-color: #F5F5F5; color: #575B68;">
                    {{selectedSlots.length}}/3
                  </span>
                </div>
                <p class="text-sm m-0" style="color: #575B68;">Select up to 3 preferred slots. Your peer picks the best match.</p>

                <div class="preferred-slots-list flex flex-column gap-3 mt-3 flex-grow-1" *ngIf="selectedSlots.length > 0">
                  <!-- Slot 1 -->
                  <div class="pref-slot flex align-items-center gap-3 p-3 border-round-xl border-1"
                       [ngClass]="{'filled': selectedSlots.length >= 1, 'empty': selectedSlots.length < 1}">
                    <div class="slot-num border-circle flex align-items-center justify-content-center font-bold">{{selectedSlots.length >= 1 ? '1' : '1'}}</div>
                    <div class="slot-info flex-grow-1">
                      <span *ngIf="selectedSlots.length >= 1" class="font-medium block" style="color: #052647;">{{selectedSlots[0].date | date: 'EEE, MMM d'}}</span>
                      <span *ngIf="selectedSlots.length >= 1" class="text-sm block" style="color: #575B68;"><i class="pi pi-clock text-xs"></i> {{selectedSlots[0].slot.from}}</span>
                      <span *ngIf="selectedSlots.length < 1" class="text-sm font-italic" style="color: #999;">choose slot</span>
                    </div>
                    <i class="pi pi-times cursor-pointer" *ngIf="selectedSlots.length >= 1" (click)="removeSlot(0)" style="color: #999;"></i>
                  </div>
                  
                  <!-- Slot 2 -->
                  <div class="pref-slot flex align-items-center gap-3 p-3 border-round-xl border-1"
                       [ngClass]="{'filled': selectedSlots.length >= 2, 'empty': selectedSlots.length < 2}">
                    <div class="slot-num border-circle flex align-items-center justify-content-center font-bold">{{selectedSlots.length >= 2 ? '2' : '2'}}</div>
                    <div class="slot-info flex-grow-1">
                      <span *ngIf="selectedSlots.length >= 2" class="font-medium block" style="color: #052647;">{{selectedSlots[1].date | date: 'EEE, MMM d'}}</span>
                      <span *ngIf="selectedSlots.length >= 2" class="text-sm block" style="color: #575B68;"><i class="pi pi-clock text-xs"></i> {{selectedSlots[1].slot.from}}</span>
                      <span *ngIf="selectedSlots.length < 2" class="text-sm font-italic" style="color: #999;">choose slot</span>
                    </div>
                    <i class="pi pi-times cursor-pointer" *ngIf="selectedSlots.length >= 2" (click)="removeSlot(1)" style="color: #999;"></i>
                  </div>

                  <!-- Slot 3 -->
                  <div class="pref-slot flex align-items-center gap-3 p-3 border-round-xl border-1"
                       [ngClass]="{'filled': selectedSlots.length >= 3, 'empty': selectedSlots.length < 3}">
                    <div class="slot-num border-circle flex align-items-center justify-content-center font-bold">{{selectedSlots.length >= 3 ? '3' : '3'}}</div>
                    <div class="slot-info flex-grow-1">
                      <span *ngIf="selectedSlots.length >= 3" class="font-medium block" style="color: #052647;">{{selectedSlots[2].date | date: 'EEE, MMM d'}}</span>
                      <span *ngIf="selectedSlots.length >= 3" class="text-sm block" style="color: #575B68;"><i class="pi pi-clock text-xs"></i> {{selectedSlots[2].slot.from}}</span>
                      <span *ngIf="selectedSlots.length < 3" class="text-sm font-italic" style="color: #999;">choose slot</span>
                    </div>
                    <i class="pi pi-times cursor-pointer" *ngIf="selectedSlots.length >= 3" (click)="removeSlot(2)" style="color: #999;"></i>
                  </div>
                </div>

                <div *ngIf="selectedSlots.length === 0" class="flex flex-column align-items-center justify-content-center p-4 border-round-2xl border-1 border-dashed mt-3 flex-grow-1" style="border-color: #E2E8F0; background-color: #FFFFFF;">
                    <i class="pi pi-calendar mb-2" style="font-size: 2rem; color: #CBD5E1;"></i>
                    <span class="text-sm font-medium" style="color: #94A3B8;">No slots added yet.</span>
                    <span class="text-xs text-center" style="color: #94A3B8;">Select a date & time from the calendar.</span>
                </div>
              </div>
              
              <div class="mt-4 pt-3 flex flex-column align-items-center justify-content-center gap-3">
                <button 
                  class="w-full border-round-3xl font-medium p-3 border-none cursor-pointer transition-colors transition-duration-200"
                  [ngStyle]="{'background-color': '#DCDA32', 'color': '#052647'}"
                  [disabled]="selectedSlots.length === 0"
                  (click)="addScheduleCall()">
                  {{ selectedSlots.length === 0 ? 'Select at least 3 time slot' : (selectedSlots.length < 3 ? 'Add ' + (3 - selectedSlots.length) + ' more slots or Confirm' : 'Confirm Request') }}
                </button>
                <p class="text-xs text-center m-0" style="color: #999; line-height: 1.4;">
                  By confirming, you're requesting a 20-min discovery call with {{peerDetail?.firstName}} {{peerDetail?.lastName}}.
                </p>
              </div>
            </div>
          </div>
      </div>
    </div>
</div>
  